/* Aleefy PRO motion — store-wide polish. Safe to fail: every block is independent. */
(function () {
  'use strict';
  var d = document, w = window;
  function mq(q) { return w.matchMedia ? w.matchMedia(q).matches : false; }
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(hover: hover) and (pointer: fine)');
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function safe(fn) { try { fn(); } catch (e) { if (w.console) console.warn('pro motion:', e); } }

  /* stagger indexes used by CSS */
  safe(function () {
    ['.thumbs .thumb', '.perks li', '.filters .chip', '.cart-row', '.ft-col'].forEach(function (s) {
      $$(s).forEach(function (el, i) { el.style.setProperty('--i', i); });
    });
  });

  /* ---------- smart header ---------- */
  safe(function () {
    var head = d.getElementById('shopify-section-header');
    if (!head || reduce) return;
    var last = w.scrollY, tick = false;
    w.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        var y = w.scrollY, drawerOpen = d.body.style.overflow === 'hidden';
        if (!drawerOpen) head.classList.toggle('pro-hide', y > last + 4 && y > 220);
        if (y < last - 4 || y < 220) head.classList.remove('pro-hide');
        last = y; tick = false;
      });
    }, { passive: true });
    head.addEventListener('focusin', function () { head.classList.remove('pro-hide'); });
  });

  /* ---------- ripple on buttons ---------- */
  safe(function () {
    if (reduce) return;
    d.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('.btn,.tx-btn,.add,.txc__add,.cart-btn,.chip,.txh__nav button,.stepper button');
      if (!b) return;
      var r = b.getBoundingClientRect(), s = Math.max(r.width, r.height) * 2.2;
      var rp = d.createElement('span');
      rp.className = 'pro-ripple';
      rp.style.width = rp.style.height = s + 'px';
      rp.style.left = (e.clientX - r.left) + 'px';
      rp.style.top = (e.clientY - r.top) + 'px';
      b.appendChild(rp);
      setTimeout(function () { rp.remove(); }, 650);
    }, { passive: true });
  });

  /* ---------- images fade + de-blur when they load ---------- */
  safe(function () {
    if (reduce) return;
    $$('main img[loading="lazy"]').forEach(function (img) {
      if (img.complete && img.naturalWidth) return;
      img.classList.add('pro-pending', 'pro-loaded');
      var done = function () { img.classList.remove('pro-pending'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
      setTimeout(done, 4000);
    });
  });

  /* ---------- custom cursor ---------- */
  safe(function () {
    if (!fine || reduce) return;
    var ring = d.createElement('div'), dot = d.createElement('div');
    ring.className = 'pro-cur'; dot.className = 'pro-dot';
    ring.setAttribute('aria-hidden', 'true'); dot.setAttribute('aria-hidden', 'true');
    ring.innerHTML = '<span>View</span>';
    d.body.appendChild(ring); d.body.appendChild(dot);
    var mx = -100, my = -100, rx = -100, ry = -100, raf = null;
    function loop() {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      ring.style.transform = 'translate(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px)' + (ring.classList.contains('is-down') ? ' scale(.85)' : '');
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
      raf = (Math.abs(mx - rx) > 0.3 || Math.abs(my - ry) > 0.3) ? requestAnimationFrame(loop) : null;
    }
    d.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      mx = e.clientX; my = e.clientY;
      d.documentElement.classList.add('pro-cursor-on');
      var t = e.target;
      var view = t.closest && t.closest('.prod-img,.txc__img,.txh__obj,.pd-img,.anim-gal__item,.cat');
      var link = !view && t.closest && t.closest('a,button,[role=button],label,select,.hp-walker');
      var dark = t.closest && t.closest('.txh,.pro-ann,.wa,.btn:not(.yellow):not(.ghost)');
      ring.classList.toggle('is-view', !!view);
      ring.classList.toggle('is-link', !!link);
      ring.classList.toggle('is-dark', !!dark && !view);
      dot.classList.toggle('is-dark', !!dark);
      var lbl = ring.firstChild;
      if (view) lbl.textContent = view.classList.contains('pd-img') ? 'Zoom' : 'View';
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    d.addEventListener('pointerdown', function () { ring.classList.add('is-down'); if (!raf) raf = requestAnimationFrame(loop); });
    d.addEventListener('pointerup', function () { ring.classList.remove('is-down'); if (!raf) raf = requestAnimationFrame(loop); });
    d.documentElement.addEventListener('mouseleave', function () { d.documentElement.classList.remove('pro-cursor-on'); });
  });

  /* ---------- product page ---------- */
  safe(function () {
    var form = $('form[data-product-form]');
    if (!form) return;
    var wrap = $('[data-main-image-wrap]');

    // zoom lens on the main image
    if (wrap && fine) {
      wrap.addEventListener('pointermove', function (e) {
        var img = $('img', wrap); if (!img) return;
        var r = wrap.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      wrap.addEventListener('pointerenter', function () { wrap.classList.add('pro-zoom'); });
      wrap.addEventListener('pointerleave', function () { wrap.classList.remove('pro-zoom'); });
    }

    // animate the main image when a thumbnail is chosen
    d.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-thumb]')) return;
      setTimeout(function () {
        var img = wrap && $('img', wrap); if (!img || reduce) return;
        img.classList.remove('pro-swap'); void img.offsetWidth; img.classList.add('pro-swap');
      }, 0);
    });

    // price pops when the variant changes
    var price = $('[data-price]');
    if (price && 'MutationObserver' in w) {
      new MutationObserver(function () {
        price.classList.remove('pro-pop'); void price.offsetWidth; price.classList.add('pro-pop');
        syncBar();
      }).observe(price, { childList: true, subtree: true, characterData: true });
    }

    // success state on the add-to-cart button
    var main = $('button[type="submit"]', form);
    form.addEventListener('submit', function () {
      if (!main) return;
      setTimeout(function () {
        main.classList.add('pro-added');
        setTimeout(function () { main.classList.remove('pro-added'); }, 1800);
      }, 700);
    });

    // sticky add-to-cart bar
    if (!main || !('IntersectionObserver' in w)) return;
    var title = $('.pd h1'), mainImg = wrap && $('img', wrap);
    var bar = d.createElement('div');
    bar.className = 'pro-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML = (mainImg ? '<img alt="" src="' + (mainImg.currentSrc || mainImg.src) + '">' : '') +
      '<div class="pro-atc__t"><b></b><span></span></div>' +
      '<button type="button" class="btn yellow">' + (main.textContent || 'Add to Cart').trim() + '</button>';
    d.body.appendChild(bar);
    var bTitle = $('b', bar), bPrice = $('span', bar), bBtn = $('button', bar);
    function syncBar() {
      if (!bTitle) return;
      bTitle.textContent = title ? (title.getAttribute('data-final') || title.textContent) : '';
      bPrice.innerHTML = price ? price.innerHTML : '';
      bBtn.disabled = !!main.disabled;
    }
    syncBar();
    bBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(main); else main.click();
    });
    new IntersectionObserver(function (es) {
      var e = es[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(main);
  });

  /* ---------- cart: bump totals when they change ---------- */
  safe(function () {
    if (!('MutationObserver' in w) || reduce) return;
    var inner = $('[data-drawer-inner]');
    if (!inner) return;
    new MutationObserver(function () {
      var tot = $('.d-foot .line strong', inner);
      if (tot) { tot.classList.remove('pro-bump'); void tot.offsetWidth; tot.classList.add('pro-bump'); }
    }).observe(inner, { childList: true });
  });

  /* ---------- footer stagger ---------- */
  safe(function () {
    var ft = $('.ft');
    if (!ft) return;
    if (reduce || !('IntersectionObserver' in w)) { ft.classList.add('pro-in'); return; }
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { ft.classList.add('pro-in'); io.disconnect(); }
    }, { threshold: 0.15 });
    io.observe(ft);
  });

  /* ---------- back to top with progress ring ---------- */
  safe(function () {
    var btn = d.createElement('button');
    btn.type = 'button';
    btn.className = 'pro-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 52 52" aria-hidden="true"><circle class="trk" cx="26" cy="26" r="24"/><circle class="bar" cx="26" cy="26" r="24"/></svg><b aria-hidden="true">↑</b>';
    d.body.appendChild(btn);
    var ring = $('.bar', btn), C = 2 * Math.PI * 24, tick = false;
    ring.style.strokeDasharray = C;
    function upd() {
      var h = d.documentElement.scrollHeight - w.innerHeight;
      var p = h > 0 ? Math.min(1, w.scrollY / h) : 0;
      ring.style.strokeDashoffset = (C * (1 - p)).toFixed(1);
      btn.classList.toggle('is-on', w.scrollY > 600);
      tick = false;
    }
    w.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
    btn.addEventListener('click', function () { w.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  });
})();
